'use strict';

var dsElementCtrl = [function() {    
    var _this=this;
    this.elementsDisabled=['title','group','autocomplete','validate'];

    const selected = this.elements && this.field && this.elements[this.field.id];
    if (selected && ['date', 'timestamp'].includes(selected.type) && selected.localeAndCutDate) {
        selected.localeAndCutDate = true;
    }

    _this.toggleCheck = function (listElements, field) {
        listElements = Array.isArray(listElements) ? {} : (listElements ? listElements : {}); // Se hace esto porque en algun momento se puso como array y tiene que ser object!

        if (listElements[field.id] == undefined) {
            listElements[field.id] = JSON.parse(JSON.stringify(field));;
            if (listElements[field.id].nodes)
                listElements[field.id].nodes = {};
        } else {
            delete listElements[field.id]
            if (field.id === 'locked') {
                delete listElements.lockedBy;
            }
        }

        this.elements = JSON.parse(JSON.stringify(listElements)); // Para asegurarse que elements sea un object
    }

    _this.copyClipboard =()=>{
        // console.log("ACA");
        navigator.clipboard.writeText(_this.field.id)
    }
}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            field: '=' ,
            elements: '=',
            toggleCheck1: '&',
            datasourceType: '@',
        },
        replace: true,
        controller: dsElementCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-graphBuilder/dataSourceElementDirective.html'
    };
};
